import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../../../users/services/user.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;
  lang: string;
  isLoading = false;

  constructor(private authService: AuthService,
              private userService: UserService,
              private router: Router,
              private fb: FormBuilder,
              private toastr: ToastrService,
              public translate: TranslateService) {
      this.createForm();
    }

  ngOnInit(): void {
    // get return url from route parameters or default to '/'
    this.initFormGroupControls();
  }

  createForm(): void {
    this.loginForm = this.fb.group({
      email: ['', Validators.required ],
      password: ['', Validators.required]
    });
  }

  private initFormGroupControls(): void {
    this.loginForm = new FormGroup({
      password: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  private isFormValid(formGroup: FormGroup): boolean {
    return formGroup.valid;
  }

  login(): void {
    if (this.isFormValid(this.loginForm)) {
      this.isLoading = true;
      this.authService.signInAndUpdate(this.loginForm.value)
        .then((userData) => {
          this.userService.getUserMetadata(userData.user);
          return userData;
        })
        .then((userData) => this.userService.isAdminByUid(userData.user.uid))
        .then(() => {
          if (this.userService.isAdmin()) {
            this.router.navigate(['/admin/lectures']);
          } else {
            this.router.navigate(['/lectures']);
          }
          this.setUserToken();
        })
        .catch((error) => {
          if (error.code.startsWith('auth/')) {
            this.toastr.error(error.message);
          } else {
            this.translate.get('GENERAL.ERROR').subscribe((text: string) => {this.toastr.error(text); });
          }
        })
        .finally(() => this.isLoading = false);
    }
  }

  private setUserToken(): void {
    this.authService.getCurrentUserToken();
  }

  signInWithGoogle(): void {
    this.authService.signInWithGoogle()
      .then(() => {
        this.router.navigate(['/lectures']);
        this.setUserToken();
      })
      .catch((error) => {
        this.toastr.error(error.message, 'Error!');
      });
  }

  signInWithFacebook(): void {
    this.authService.signInWithFacebook()
      .then(() => {
        this.router.navigate(['/lectures']);
        this.setUserToken();
      })
      .catch((error) => {
        this.toastr.error(error.message, 'Error!');
      });
  }
}
